import { render, staticRenderFns } from "./ZxgcsAdd.vue?vue&type=template&id=abf22d28"
import script from "./ZxgcsAdd.vue?vue&type=script&lang=js"
export * from "./ZxgcsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports